import { LANGUAGE } from "@/common/utils/constants.js";

export const ADDITIONAL_INFORMATION_PPT = {
	[LANGUAGE.en.short]: {
		title: `Project’s Key Metrics`,
		techPractices: `Tech Practices > Sub Tech Practices`,
		keysData: `Project\`s locations`,
		deliveryLocations: `Project Delivery Locations`,
		clientLocations: `Client’s Locations Covered`,
		serviceLines: `Type of Business > Models`,
		attributes: `Tools & Certifications`,
		tools: `<b>Tools</b>:`,
		certificates: `<b>Certifications</b>:`,
		noToolsUsed: 'N/A',
		noCertificationsUsed: 'N/A',
		ongoing: 'Ongoing'
	},
	[LANGUAGE.de.short]: {
		title: `Die wichtigsten Kennzahlen des Projekts`,
		techPractices: `Tech-Praktiken > Sub-Tech-Praktiken`,
		keysData: `Projektstandorte`,
		deliveryLocations: `Standorte für die Projektabwicklung`,
		clientLocations: `Abgedeckte Standorte des Kunden`,
		serviceLines: `Geschäftsart > Modelle`,
		attributes: `Werkzeuge und Zertifizierungen`,
		tools: `<b>Werkzeug</b>:`,
		certificates: `<b>Zertifizierungen</b>:`,
		noToolsUsed: 'N/A',
		noCertificationsUsed: 'N/A',
		ongoing: 'Laufend'
	},
	[LANGUAGE.fr.short]: {
		title: `Indicateurs clés du projet`,
		techPractices: `Pratiques techniques > Pratiques techniques secondaires`,
		keysData: `Emplacements du projet`,
		deliveryLocations: `Lieux de livraison du projet`,
		clientLocations: `Emplacements du client couverts`,
		serviceLines: `Type d'entreprise > Modèles`,
		attributes: `Outils et certifications`,
		tools: `<b>Outils</b>:`,
		certificates: `<b>Certifications</b>:`,
		noToolsUsed: 'N/A',
		noCertificationsUsed: 'N/A',
		ongoing: 'En cours'
	},
	[LANGUAGE.it.short]: {
		title: `Metriche chiave del progetto`,
		techPractices: `Pratiche tecniche > Pratiche tecniche secondarie`,
		keysData: `Le sedi del progetto`,
		deliveryLocations: `Luoghi di consegna del progetto`,
		clientLocations: `Sedi del cliente coperte`,
		serviceLines: `Tipo di attività > Modelli`,
		attributes: `Strumenti e certificazioni`,
		tools: `<b>Utensili</b>:`,
		certificates: `<b>Certificazioni</b>:`,
		noToolsUsed: 'N/A',
		noCertificationsUsed: 'N/A',
		ongoing: 'Incorso'
	},
	[LANGUAGE.ja.short]: {
		title: `プロジェクトの主要な指標`,
		techPractices: `技術的実践 > サブ技術的実践`,
		keysData: `プロジェクトの場所`,
		deliveryLocations: `プロジェクトの納品場所`,
		clientLocations: `対象となるクライアントの所在地`,
		serviceLines: `業種`,
		attributes: `ツールと認定`,
		tools: `<b>ツール</b>:`,
		certificates: `<b>認証</b>:`,
		noToolsUsed: 'N/A',
		noCertificationsUsed: 'N/A',
		ongoing: '進行中'
	},
	[LANGUAGE.es.short]: {
		title: `Métricas clave del proyecto`,
		techPractices: `Prácticas técnicas > Subprácticas técnicas`,
		keysData: `Ubicaciones del proyecto`,
		deliveryLocations: `Ubicaciones de entrega del proyecto`,
		clientLocations: `Ubicaciones del cliente cubiertas`,
		serviceLines: `Tipo de negocio > Modelos`,
		attributes: `Herramientas y certificaciones`,
		tools: `<b>Herramientas</b>:`,
		certificates: `<b>Certificaciones</b>:`,
		noToolsUsed: 'N/A',
		noCertificationsUsed: 'N/A',
		ongoing: 'En curso'
	}
}
